import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { motion } from "framer-motion";

function NavItem({ label, to, isActive }) {
  const [hovered, setHovered] = useState(false);
  const showEffect = hovered || isActive;

  return (
    <motion.div
      data-testid={`nav-item-${label.toLowerCase()}`}
      style={{ 
        position: "relative", 
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "80px",
        height: "36px",
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {/* Lime green background for selected/hovered state */}
      <motion.div
        style={{
          position: "absolute",
          inset: 0,
          borderRadius: "4px",
          background: "#BFFF00",
          zIndex: 0,
        }}
        initial={{ opacity: 0, scaleX: 0.8 }}
        animate={{ 
          opacity: showEffect ? 1 : 0,
          scaleX: showEffect ? 1 : 0.8,
        }}
        transition={{ duration: 0.2, ease: "easeOut" }}
      />

      <Link
        to={to}
        data-testid={`nav-link-${label.toLowerCase()}`}
        style={{
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          height: "100%",
          fontFamily: "'Garet', sans-serif",
          fontWeight: 700,
          fontSize: "0.85rem",
          letterSpacing: "0.02em",
          textTransform: "uppercase",
          color: "#1a1a1a",
          textDecoration: "none",
          userSelect: "none",
          zIndex: 1,
        }}
      >
        {label}
      </Link>
    </motion.div>
  );
}

export default function PortfolioNav({ dark = false }) {
  const location = useLocation();
  
  const navItems = [
    { label: "Home", to: "/" },
    { label: "Works", to: "/works" },
    { label: "About", to: "/about" },
  ];

  return (
    <nav
      data-testid="portfolio-nav"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "16px",
        padding: "clamp(20px, 3vh, 32px) clamp(24px, 5vw, 52px)",
        pointerEvents: "auto",
      }}
    >
      {navItems.map((item) => (
        <NavItem 
          key={item.label} 
          label={item.label} 
          to={item.to} 
          isActive={location.pathname === item.to || 
            (item.to === "/works" && location.pathname.startsWith("/project"))}
        />
      ))}
    </nav>
  );
}
